import { isEmpty, pick } from "lodash";
import React, { useState, useContext, useRef, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import AuthProvider from "../context/AuthContext";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import Aboutus from "../components/staticContent/Aboutus";
import GeneralTerms from "../components/staticContent/GeneralTerms";
import Kyc from "../components/staticContent/Kyc";
import PrivacyPolicy from "../components/staticContent/PrivacyPolicy";
import RulesRegulation from "../components/staticContent/RulesRegulation";
import ResponsibleGaming from "../components/staticContent/ResponsibleGaming";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { IoIosRefresh } from "react-icons/io";
import { MdRefresh } from "react-icons/md";
import { toast } from "wc-toast";


function ChangePassword({ setShowChangePassword }) {

    const [passwordType, setPasswordType] = useState("password");
    const [passwordType1, setPasswordType1] = useState("password");
    const [passwordType2, setPasswordType2] = useState("password");
    const navigate = useNavigate();

    const togglePassword = (e) => {
        e.preventDefault()
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const togglePassword1 = (e) => {
        e.preventDefault()
        if (passwordType1 === "password") {
            setPasswordType1("text")
            return;
        }
        setPasswordType1("password")
    }

    const togglePassword2 = (e) => {
        e.preventDefault()
        if (passwordType2 === "password") {
            setPasswordType2("text")
            return;
        }
        setPasswordType2("password")
    }

    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm();

    const [isLoader, setLoader] = useState(false);

    const newPassword = watch("newPassword");

    const onSubmit = async (request) => {
        if (request.newPassword !== request.confirmPassword) {
            alert("Password does not match");
            return;
        }

        try {
            setLoader(true);

            const { status, data: response_users } = await apiPost(
                apiPath.changePassword,
                {
                    oldPassword: request.oldPassword,  
                    newPassword: request.newPassword
                }
                // pick(request, ["oldPassword", "newPassword"])
            );

            if (status === 200) {
                if (response_users.success) {
                    alert(response_users.message);
                    navigate('/');
                    // setShowChangePassword(false);
                    localStorage.setItem("pass_changed", "true");
                    reset();
                }
                else {
                    alert(response_users.message);
                }
            }
        } catch (err) {
            alert("Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    return (
        <div>
            <div className="login_main">
                <header className="login-head">
                    {/* <Link to="/userhome" className="close"></Link> */}
                    <h1 style={{ backgroundSize: "contain" }}></h1>


                </header>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <dl className="form-login">
                        <div className="" style={{ textAlign: 'center', marginBottom: '15px', fontSize: '18px' }}>Change Password</div>
                        {/* Old Password */}
                        <Form.Group style={{ marginBottom: "10px" }}>
                            <div style={{ position: 'relative' }}>
                            <Form.Control
                                type={passwordType1 ? passwordType1 : "password"}
                                placeholder="Current Password"
                                className={errors.oldPassword ? "is-invalid" : ""}
                                {...register("oldPassword", {
                                    required: "Please enter current password",
                                })}
                            />
                            <div className="input-group-btn" style={{ position: 'absolute', right: '0', top: '0', bottom: '0px' }}>
                                    <span className="btn btn-outline-primary" onClick={togglePassword1} style={{ backgroundColor: 'transparent', backgroundImage: `none`, border: '0', padding: '8px 6px', paddingTop: '3px', height: '100%', marginBottom:'0', display:'flex', alignItems:'center', color:'#1e1e1e', fontSize: `6.5vw`, lineHeight: `1.8` }}>
                                        {passwordType1 === "password" ? <AiFillEyeInvisible /> : <AiFillEye />}
                                    </span>
                                </div>
                            </div>
                            {errors.oldPassword && (
                                <label className="invalid-feedback text-left">
                                    {errors.oldPassword.message}
                                </label>
                            )}
                        </Form.Group>

                        {/* New Password */}

                        <Form.Group style={{ marginBottom: "10px" }}>
                            <div style={{ position: 'relative' }}>
                                <Form.Control
                                    type={passwordType ? passwordType : "password"}
                                    placeholder="New Password"
                                    className={errors.newPassword ? "is-invalid" : ""}
                                    {...register("newPassword", {
                                        required: "Please enter new password",
                                    })}
                                />
                                <div className="input-group-btn" style={{ position: 'absolute', right: '0', top: '0', bottom: '0px' }}>
                                    <span className="btn btn-outline-primary" onClick={togglePassword} style={{ backgroundColor: 'transparent', backgroundImage: `none`, border: '0', padding: '8px 6px', paddingTop: '3px', height: '100%', marginBottom: '0', display: 'flex', alignItems: 'center', color: '#1e1e1e', fontSize: `6.5vw`, lineHeight: `1.8` }}>
                                        {passwordType === "password" ? <AiFillEyeInvisible /> : <AiFillEye />}
                                    </span>
                                </div>
                            </div>
                            {errors.newPassword && (
                                <label className="invalid-feedback text-left">
                                    {errors.newPassword.message}
                                </label>
                            )}
                        </Form.Group>

                        {/* Confirm Password */}
                        <Form.Group style={{ marginBottom: "10px" }}>
                            <div style={{ position: 'relative' }}>
                                <Form.Control
                                    type={passwordType2 ? passwordType2 : "password"}
                                    placeholder="Confirm New Password"
                                    className={
                                        errors.confirmPassword ? "is-invalid" : ""
                                    }
                                    {...register("confirmPassword", {
                                        required: "Please confirm password",
                                        validate: (value) =>
                                            value === newPassword || "Password does not match",
                                    })}
                                />
                                <div className="input-group-btn" style={{ position: 'absolute', right: '0', top: '0', bottom: '0px' }}>
                                    <span className="btn btn-outline-primary" onClick={togglePassword2} style={{ backgroundColor: 'transparent', backgroundImage: `none`, border: '0', padding: '8px 6px', paddingTop: '3px', height: '100%', marginBottom: '0', display: 'flex', alignItems: 'center', color: '#1e1e1e', fontSize: `6.5vw`, lineHeight: `1.8` }}>
                                        {passwordType2 === "password" ? <AiFillEyeInvisible /> : <AiFillEye />}
                                    </span>
                                </div>
                            </div>
                            {errors.confirmPassword && (
                                <label className="invalid-feedback text-left">
                                    {errors.confirmPassword.message}
                                </label>
                            )}
                        </Form.Group>

                        <dd>
                            <Button type="submit" className="btn-send w-100">
                                {isLoader ? "Loading..." : "Change Password"}
                            </Button>
                        </dd>
                    </dl>
                </Form>



                {/* <div id="supportWrap" class="support-wrap">
                    <div class="support-service">

                        <a href="#" target="_blank" className="support-whatsapp open support-whatsapp"
                            style={{ background: 'transparent' }}>
                            <LazyLoadImage src="/assets/images/socialicon/telegram.png" alt="whatsApp" title="WhatsApp" />
                        </a>
                        <a href="#" target="_blank" className="support-whatsapp open support-whatsapp">
                            <LazyLoadImage src="/assets/images/socialicon/gmail.png" alt="whatsApp" title="WhatsApp" />
                        </a>
                        <a href="https://wa.me/918404067276" target="_blank" className="support-whatsapp open support-whatsapp">
                            <LazyLoadImage src="/assets/images/socialicon/whatsapp.png" alt="whatsApp" title="WhatsApp" />
                        </a>
                        <a href="https://www.facebook.com/share/187UwdW8Ru/" target="_blank" className="support-whatsapp open support-whatsapp">
                            <LazyLoadImage src="/assets/images/socialicon/facebook.png" alt="whatsApp" title="WhatsApp" />
                        </a>
                        <a href="#" target="_blank" className="support-whatsapp open support-whatsapp">
                            <LazyLoadImage src="/assets/images/socialicon/social.png" alt="whatsApp" title="WhatsApp" />
                        </a>
                        <a href="#" target="_blank" className="support-whatsapp open support-whatsapp">
                            <LazyLoadImage src="/assets/images/socialicon/messenger.png" alt="whatsApp" title="WhatsApp" />
                        </a>
                    </div>
                </div> */}

                {/* static-content */}


                {/* static-content */}



            </div>
        </div>
    );
}

export default ChangePassword;
